module.exports = __webpack_public_path__ + "static/img/A46.33c65cc2.jpg";